import React from "react"
import { HugoStateApi } from "../hugo"
import useStartpageHugo from "./useStartpageHugo"
import { Cell, Icon, Paper, Row, Wall, mailIcon } from "../ui"
import plan from "./assets/plan.png"
import portrait from "./assets/portrait.jpg"
import styled from "styled-components"

import papertape4 from '../ui/paper/assets/papertape4.png'

type Props = {
    hugoApi: HugoStateApi
}

const Startpage: React.FC<Props> = ({ hugoApi }) => {
    const [setCommand, booted] = useStartpageHugo(hugoApi)

    return (
        <Wall>
            <Paper>
                <Row $skewStrength={3}>
                    <Cell $width={2}>
                        <p>Hey, my name is Alex!</p>
                        <p>This is my application system test laboratory, feel free to interact with the exhibition pieces (mouse / keyboard)!</p>
                    </Cell>
                </Row>
                <Row $skewStrength={3}>
                    <Cell $width={2}>
                        <p>
                            If one of the systems works successfully and arranged a job offer, please contact me immediately!
                        </p>
                        <p><Icon src={mailIcon} /> <a href="mailto:alexander@muehrenberg"><strong>alexander@muehrenberg</strong></a></p>
                        <p>Phone: <a href="tel:+4915756692788"><strong>01575 / 66 927 88</strong></a></p>
                        <p></p>
                    </Cell>
                </Row>
                <Row $skewStrength={1}>
                    <Cell $width={2} style={{ flexDirection: 'row', display: 'flex' }}>
                        {booted ? (
                            <>
                                <div style={{ marginRight: '4rem' }}>
                                    <h3>Commands</h3>
                                    <ul>
                                        <li><a href="#" onClick={(event) => { event.preventDefault(); setCommand('cv') }}>"<strong>cv</strong>"</a></li>
                                        <li><a href="#" onClick={(event) => { event.preventDefault(); setCommand('contact') }}>"<strong>contact</strong>"</a></li>
                                        <li><a href="#" onClick={(event) => { event.preventDefault(); setCommand('hobbies') }}>"<strong>hobbies</strong>"</a></li>
                                        <li><a href="#" onClick={(event) => { event.preventDefault(); setCommand('languages') }}>"<strong>languages</strong>"</a></li>
                                        <li><a href="#" onClick={(event) => { event.preventDefault(); setCommand('more') }}>"<strong>more</strong>"</a></li>
                                    </ul>
                                </div>
                                <div>
                                    <p>
                                        P.S.: Don't <a href="#" onClick={(event) => { event.preventDefault(); setCommand('test') }}><strong>test</strong></a> Hugo or <a href="#" onClick={(event) => { event.preventDefault(); setCommand('hack') }}><strong>hack</strong></a> him, he doesn't really like that.
                                        Better ask for some <a href="#" onClick={(event) => { event.preventDefault(); setCommand('music') }}><strong>music</strong></a>! =)
                                    </p>
                                </div>
                            </>
                        ): (
                            <p><strong>Tip</strong>: Try to <strong>boot</strong> Hugo!</p>
                        )}
                    </Cell>
                </Row>
            </Paper>


            <Paper $rotate={3}>
                <Row $skewStrength={0.5} $contrast={100} $saturate={100} $brightness={100} $dense>
                    <Cell $width={1} style={{ textAlign: 'center' }}  $image>
                        <img src={portrait} />
                    </Cell>
                </Row>
            </Paper>

            <Paper $rotate={-3}>
                <Row $height={1.9} $skewStrength={0.5} $hueRotate={100} $contrast={100} $saturate={170} $brightness={95}>
                    <Cell $width={1.5} style={{ textAlign: 'center' }}>
                        <h2 style={{ margin: 0 }}>Master Plan</h2>
                        <img src={plan} style={{ width: '100%', opacity: 0.8 }} />
                    </Cell>
                </Row>
            </Paper>
        </Wall>
    )
}

export default Startpage